import { Configurable, createSiteConfig, forBrand, environment } from "@crystal/config";
import * as index from "./sites/index.js";
const defaultSiteConfig = Configurable.props({
  minLegalAge: 18
});
const siteConfig = createSiteConfig(
  index,
  defaultSiteConfig
);
const accountConfig = Configurable.props({
  minLegalAge: siteConfig.prop("minLegalAge"),
  recaptchaSiteKey: forBrand({
    adidas: environment({
      production: "6LdQquAaAAAAALeU6cp88M5ByhWDANC1-ei8xfMW",
      // PROD key: https://console.cloud.google.com/security/recaptcha/6LdQquAaAAAAALeU6cp88M5ByhWDANC1-ei8xfMW/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
      staging: "6LcKLyAdAAAAAD4kalS8K6HuydkxWgxH0kHxFAp2",
      // STG key: https://console.cloud.google.com/security/recaptcha/6LcKLyAdAAAAAD4kalS8K6HuydkxWgxH0kHxFAp2/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
      default: "6LdxdSEdAAAAAD3X1KHxT4ydfAE_2Fw9qmpPFCKc"
      // DEV key: https://console.cloud.google.com/security/recaptcha/6LdxdSEdAAAAAD3X1KHxT4ydfAE_2Fw9qmpPFCKc/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
    }),
    reebok: environment({
      production: "6LcrwjMcAAAAADit7C37UQ1Ei7mfWgy2089OJvjZ",
      // PROD key: https://console.cloud.google.com/security/recaptcha/6LcrwjMcAAAAADit7C37UQ1Ei7mfWgy2089OJvjZ/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
      staging: "6LffciEdAAAAALTsf_C7qczph5NQ_1pMP75HWQBI",
      // STG key: https://console.cloud.google.com/security/recaptcha/6LffciEdAAAAALTsf_C7qczph5NQ_1pMP75HWQBI/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
      default: "6LdxdSEdAAAAAD3X1KHxT4ydfAE_2Fw9qmpPFCKc"
      // DEV key: https://console.cloud.google.com/security/recaptcha/6LdxdSEdAAAAAD3X1KHxT4ydfAE_2Fw9qmpPFCKc/details?orgonly=true&project=adidas-web-recaptcha&supportedpurview=organizationId
    })
  })
});
export {
  accountConfig
};
//# sourceMappingURL=config.js.map
